import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";
import { Button, Card, Dropdown } from "react-bootstrap";

//
import NewPortfolioModal from "./NewPortfolioModal";

//
import Icon from "../../assets/img/coin.svg";

//
import { setActivePortfolio } from "../../redux/features/portfolio/slice";
import NumberFormat from "react-number-format";

function UserPortfolios({
  portfolios,
  activePortfolio,
  setActivePortfolio,
  windowSize,
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="user-portfolio-list">
      {windowSize >= 768 ? (
        <>
          <Button
            size="lg"
            variant="info"
            className="modal-btn"
            onClick={() => setShow(true)}
          >
            <i className="las la-plus-circle text-white" />
            Create New Portfolio
          </Button>

          {portfolios.length > 0 &&
            portfolios.map((item) => (
              <Card
                className={`item ${
                  activePortfolio?.info?.id === item?.info?.id ? "active" : ""
                } ${!item.active ? "disabled" : ""}`}
                key={item?.info?.id}
                onClick={() => setActivePortfolio(item)}
              >
                <Card.Body>
                  <div className="holder">
                    <img src={Icon} alt="icon" />

                    <div>
                      <p className="text-black fw-extra-bolder truncate">
                        {item?.info?.name}
                      </p>
                      <small>
                        Valuation :
                        <p className="valuation">
                          <NumberFormat
                            value={item?.balances?.USDT}
                            prefix="$"
                            decimalScale="2"
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalSeparator="."
                            className="ms-1 mb-1"
                          />

                          <NumberFormat
                            value={item?.balances?.BTC}
                            prefix="₿"
                            decimalScale="8"
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalSeparator="."
                            className="ms-1"
                          />
                        </p>
                      </small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}
        </>
      ) : (
        <>
          {portfolios.length ? (
            <Dropdown align="end">
              <Dropdown.Toggle className="full">
                <Card className="item w-100">
                  <Card.Body>
                    <div className="holder">
                      <img src={Icon} alt="icon" />

                      <div>
                        <p className="text-black fw-extra-bolder truncate">
                          {activePortfolio?.info?.name}
                        </p>
                        <small>
                          Valuation :
                          <p className="valuation">
                            <NumberFormat
                              value={activePortfolio?.balances?.USDT}
                              prefix="$"
                              decimalScale="2"
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalSeparator="."
                              className="ms-1 mb-1"
                            />
                            <NumberFormat
                              value={activePortfolio?.balances?.BTC}
                              prefix="₿"
                              decimalScale="8"
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalSeparator="."
                              className="ms-1"
                            />
                          </p>
                        </small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Dropdown.Toggle>

              <Dropdown.Menu className="fit">
                <Dropdown.Item>
                  <Button
                    size="lg"
                    variant="info"
                    className="modal-btn"
                    onClick={() => setShow(true)}
                  >
                    <i className="las la-plus-circle text-white" />
                    Create New Portfolio
                  </Button>
                </Dropdown.Item>
                <ScrollBar>
                  {portfolios.map((item) => (
                    <Dropdown.Item key={item.info.id}>
                      <Card
                        className={`item 
                        ${
                          activePortfolio?.info?.id === item?.info?.id
                            ? "active"
                            : ""
                        } 
                        ${!item.active ? "disabled" : ""}`}
                        key={item?.info?.id}
                        onClick={() => setActivePortfolio(item)}
                      >
                        <Card.Body>
                          <div className="holder">
                            <img src={Icon} alt="icon" />

                            <div>
                              <p className="text-black fw-extra-bolder truncate">
                                {item.info.name}
                              </p>
                              <small>
                                Valuation :
                                <p className="valuation">
                                  <NumberFormat
                                    value={item?.balances?.USDT}
                                    prefix="$"
                                    decimalScale="2"
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalSeparator="."
                                    className="ms-1 mb-1"
                                  />

                                  <NumberFormat
                                    value={item?.balances?.BTC}
                                    prefix="₿"
                                    decimalScale="8"
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalSeparator="."
                                    className="ms-1"
                                  />
                                </p>
                              </small>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Dropdown.Item>
                  ))}
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Button
              size="lg"
              variant="info"
              className="modal-btn"
              onClick={() => setShow(true)}
            >
              <i className="las la-plus-circle text-white" />
              Create New Portfolio
            </Button>
          )}
        </>
      )}

      <NewPortfolioModal show={show} setShow={(status) => setShow(status)} />
    </div>
  );
}

UserPortfolios.propTypes = {
  portfolios: PropTypes.array.isRequired,
  activePortfolio: PropTypes.object.isRequired,
  setActivePortfolio: PropTypes.func.isRequired,
  windowSize: PropTypes.number.isRequired,
};

const mapDispatchToProps = {
  setActivePortfolio,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
  portfolios: state.portfolioReducer.portfolios,
  activePortfolio: state.portfolioReducer.activePortfolio,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPortfolios);
